/**
 * Values match the dw.supply.pos_reporting_ticket_group_agg table in SF
 */
export enum TicketStatus {
  Cancelled = 'Cancelled',
  Sold = 'Sold',
  Available = 'Available',
  AvailableSold = 'Available / Sold',
}
